"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.postsResult = exports.postsIsLoading = exports.updateBookmark = exports.getPostsResultByFilter = exports.getBookmarkedIds = exports.getPostsResultByViewBox = exports.bookmarkUpdated = exports.getBookmarkedIdsSuccess = exports.getSearchResultFailure = exports.getSearchResultSuccess = exports.getSearchResult = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var axios_1 = __importDefault(require("axios"));
var lodash_1 = __importDefault(require("lodash"));
var postsInitialState = {
    current_page: 0,
    data: [],
    first_page_url: '',
    from: 0,
    last_page: 0,
    last_page_url: '',
    links: [],
    next_page_url: '',
    path: '',
    per_page: 0,
    prev_page_url: null,
    to: 0,
    total: 0,
};
var initialState = {
    posts: postsInitialState,
    bookmarkedPostIds: [],
    loading: false,
};
var searchResultSlice = toolkit_1.createSlice({
    name: 'searchResult',
    initialState: initialState,
    reducers: {
        getSearchResult: function (state) {
            state.loading = true;
        },
        getSearchResultSuccess: function (state, action) {
            state.posts = action.payload;
            state.loading = false;
        },
        getSearchResultFailure: function (state) {
            state.loading = false;
        },
        getBookmarkedIdsSuccess: function (state, action) {
            state.bookmarkedPostIds = action.payload;
        },
        bookmarkUpdated: function (state, action) {
            var _a = action.payload, id = _a.id, bookmark = _a.bookmark;
            if (bookmark) {
                state.bookmarkedPostIds.push(id);
            }
            else {
                lodash_1.default.pull(state.bookmarkedPostIds, id);
            }
        },
    },
});
exports.getSearchResult = (_a = searchResultSlice.actions, _a.getSearchResult), exports.getSearchResultSuccess = _a.getSearchResultSuccess, exports.getSearchResultFailure = _a.getSearchResultFailure, exports.getBookmarkedIdsSuccess = _a.getBookmarkedIdsSuccess, exports.bookmarkUpdated = _a.bookmarkUpdated;
var getPostsResultByViewBox = function (payload) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var data, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch(exports.getSearchResult());
                    return [4 /*yield*/, axios_1.default.post("/api/search/posts?page=" + payload.page, {
                            params: {
                                viewBox: payload.viewBox,
                                multiPolygon: payload.multiPolygon,
                                filters: payload.filters,
                                sortBy: payload.sortBy,
                            },
                        })];
                case 1:
                    data = (_a.sent()).data.data;
                    dispatch(exports.getSearchResultSuccess(data.posts));
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _a.sent();
                    dispatch(exports.getSearchResultFailure());
                    throw e_1;
                case 3:
                    if (!payload.withBookmarks) {
                        return [2 /*return*/];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
};
exports.getPostsResultByViewBox = getPostsResultByViewBox;
var getBookmarkedIds = function () {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var ids, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, axios_1.default.get('/api/wishlists/post-ids')];
                case 1:
                    ids = (_b.sent()).data.ids;
                    dispatch(exports.getBookmarkedIdsSuccess(ids));
                    return [3 /*break*/, 3];
                case 2:
                    _a = _b.sent();
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
exports.getBookmarkedIds = getBookmarkedIds;
var getPostsResultByFilter = function (payload) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var data, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch(exports.getSearchResult());
                    return [4 /*yield*/, axios_1.default.post("/api/search/filter-posts?page=" + payload.page, {
                            params: {
                                filters: payload.filters,
                                sortBy: payload.sortBy,
                            },
                        })];
                case 1:
                    data = (_a.sent()).data.data;
                    dispatch(exports.getSearchResultSuccess(data.posts));
                    return [3 /*break*/, 3];
                case 2:
                    e_2 = _a.sent();
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
exports.getPostsResultByFilter = getPostsResultByFilter;
var updateBookmark = function (id, bookmark) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            dispatch(exports.bookmarkUpdated({
                id: id,
                bookmark: bookmark,
            }));
            return [2 /*return*/];
        });
    }); };
};
exports.updateBookmark = updateBookmark;
var postsIsLoading = function (state) { return state.searchResult.loading; };
exports.postsIsLoading = postsIsLoading;
var postsResult = function (state) {
    if (!state.searchResult.posts.data) {
        return state.searchResult.posts;
    }
    return __assign(__assign({}, state.searchResult.posts), { data: state.searchResult.posts.data.map(function (p) {
            return __assign(__assign({}, p), { bookmarked: lodash_1.default.includes(state.searchResult.bookmarkedPostIds, p.id) });
        }) });
};
exports.postsResult = postsResult;
exports.default = searchResultSlice.reducer;
